import { Card, Typography } from "@norican/react";

import type { MatchingInvestigationSummary, MatchingSourceEvidence } from "@/lib/api";

/** A checked citation contains a source label and a location, never source contents. */
export function sourceCitationText(source: MatchingSourceEvidence): string {
  return [
    source.label,
    source.page ? `page ${source.page}` : null,
    source.sheet,
    source.row ? `row ${source.row}` : null,
  ]
    .filter(Boolean)
    .join(", ");
}

/** The same concise citations beside customers and lines on both sales surfaces. */
export function MatchingSources({ sources }: { sources?: MatchingSourceEvidence[] | null }) {
  if (!sources?.length) {
    return null;
  }
  return (
    <span className="flex flex-col gap-0.5" data-matching-sources>
      {sources.map((source, index) => (
        <Typography key={index} variant="caption" tone="muted" className="break-words">
          Source: {sourceCitationText(source)}
        </Typography>
      ))}
    </span>
  );
}

/** Only applied suggestions reach this card; observation traces stay on the server. */
export function MatchingReview({ review }: { review?: MatchingInvestigationSummary | null }) {
  if (!review || (!review.questions?.length && !review.sources?.length)) {
    return null;
  }
  return (
    <Card variant="outline" data-matching-review>
      <Card.Header>
        <Typography variant="body-sm">Check before quoting</Typography>
      </Card.Header>
      <Card.Body className="flex flex-col gap-2">
        {review.questions?.map((question, index) => (
          <Typography key={index} variant="body-sm">
            {question}
          </Typography>
        ))}
        <MatchingSources sources={review.sources} />
      </Card.Body>
    </Card>
  );
}
